module.exports = __webpack_public_path__ + "static/media/New Beginnings Brochure.b0674044.pdf";